import { Box } from "@mui/joy";
import { motion } from "framer-motion";

/**
 * Значок бренда в шапках экранов.
 *
 * Путь к картинке — АБСОЛЮТНЫЙ (`/logo.png`). Раньше здесь было `logo.png`
 * без слеша: путь считался от текущего адреса, и на вложенных маршрутах
 * (например, /union/12) браузер просил /union/logo.png, получал 404 и рисовал
 * битую картинку или подставлял закэшированную старую.
 */
export default function LogoTitle({ size = 40 }) {
    return (
        <Box
            component={motion.div}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: 'spring', stiffness: 320, damping: 22 }}
            sx={{
                width: size,
                height: size,
                flex: 'none',
                display: 'grid',
                placeItems: 'center',
            }}
        >
            <img
                src="/logo.png"
                alt="Lovirds"
                width={size}
                height={size}
                style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
            />
        </Box>
    );
}
